export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M7.817 4a2 2 0 0 1 2 2v.743h10.957a1.25 1.25 0 0 0-1.25-1.243h-6.53a.75.75 0 0 1 0-1.5h6.53a2.75 2.75 0 0 1 2.75 2.75v5.386h-.003V19a1 1 0 0 1-1 1h-18l-.102-.005A1 1 0 0 1 2.271 19V6a2 2 0 0 1 1.796-1.99L4.271 4h3.546ZM4.271 5.5a.5.5 0 0 0-.5.5v12.5h17V8.243H9.817a1.5 1.5 0 0 1-1.5-1.5V6a.5.5 0 0 0-.5-.5H4.271Z"/>
</svg>
`;
